import { render, staticRenderFns } from "./PaymentRoundInformation.vue?vue&type=template&id=af1480e0&scoped=true&"
import script from "./PaymentRoundInformation.vue?vue&type=script&lang=js&"
export * from "./PaymentRoundInformation.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRoundInformation.vue?vue&type=style&index=0&id=af1480e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1480e0",
  null
  
)

export default component.exports